export default "__VITE_ASSET__OTmCRkXj__"